import { ITaskAttachment } from '../../models/taskAttachment.model';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { AppAction } from '../app';
import {
  CLEAR_TASK_ATTACHMENT,
  CREATE_TASK_ATTACHMENT,
  FETCH_TASK_ATTACHMENT,
  FETCH_TASK_ATTACHMENT_LIST,
  UPDATE_TASK_ATTACHMENT,
} from './taskAttachment.actions';
import { TaskAttachmentState } from './taskAttachment.types';

const initialState: TaskAttachmentState = {
  errorMessage: '',
  item: {} as Readonly<ITaskAttachment>,
  items: [],
  loading: false,
  totalItems: 0,
};

export default (
  state: TaskAttachmentState = initialState,
  action: AppAction,
): TaskAttachmentState => {
  switch (action.type) {
    case REQUEST(FETCH_TASK_ATTACHMENT_LIST):
    case REQUEST(CREATE_TASK_ATTACHMENT):
    case REQUEST(FETCH_TASK_ATTACHMENT):
    case REQUEST(UPDATE_TASK_ATTACHMENT):
      return { ...state, loading: true };
    case SUCCESS(FETCH_TASK_ATTACHMENT_LIST):
      return {
        ...state,
        items: action.payload.data,
        loading: false,
        totalItems: +action.payload.headers['x-total-count'],
      };
    case FAILURE(FETCH_TASK_ATTACHMENT_LIST):
    case FAILURE(CREATE_TASK_ATTACHMENT):
    case FAILURE(FETCH_TASK_ATTACHMENT):
    case FAILURE(UPDATE_TASK_ATTACHMENT):
      return { ...state, loading: false, errorMessage: action.payload.errorMessage };
    case SUCCESS(CREATE_TASK_ATTACHMENT):
    case SUCCESS(FETCH_TASK_ATTACHMENT):
    case SUCCESS(UPDATE_TASK_ATTACHMENT):
      return { ...state, loading: false, item: action.payload.data };
    case CLEAR_TASK_ATTACHMENT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
